// Wrapper GA4 (gtag.js). Lo snippet base è in public/index.html.
export const GA_ID = "G-SGXBYDMG0B";

export function track(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

export function trackPageview() {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: window.location.pathname + window.location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
}

const PARTNER_EVENTS = { partner_view: "view", partner_call: "call", partner_whatsapp: "whatsapp", partner_directions: "directions" };

export function trackPartner(name, slug, params = {}) {
  track(name, { slug, ...params });
  const type = PARTNER_EVENTS[name];
  if (!type || !slug) return;
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/partner-pages/${encodeURIComponent(slug)}/event`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ type }), keepalive: true,
    }).catch(() => {});
  } catch { /* ignore */ }
}
